import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Loader from "../../../components/Loader";
import Row from "./Row";

const Table = ({ 
  sessions = [], 
  loading, 
  error, 
  noResults, 
  selectedIds = [], 
  onSelectionChange, 
  onStatusChange, 
  onDeleteSession, 
  onDuplicateSession 
}) => {
  const [chooseAll, setChooseAll] = useState(false);

  // Mettre à jour l'état "Tout sélectionner" en fonction des sélections
  useEffect(() => {
    if (sessions.length > 0) {
      setChooseAll(sessions.every(session => selectedIds.includes(session.id)));
    } else {
      setChooseAll(false);
    }
  }, [sessions, selectedIds]);

  const handleChooseAll = () => {
    const newChooseAll = !chooseAll;
    console.log('handleChooseAll called:', { newChooseAll, sessionsCount: sessions.length });
    
    if (newChooseAll) {
      // Sélectionner toutes les sessions
      sessions.forEach(session => {
        console.log('Selecting session:', session.id);
        onSelectionChange(session.id, true);
      });
    } else {
      // Désélectionner toutes les sessions
      sessions.forEach(session => {
        console.log('Deselecting session:', session.id);
        onSelectionChange(session.id, false);
      });
    }
  };

  const handleRowSelectionChange = (sessionId) => {
    const isSelected = selectedIds.includes(sessionId);
    onSelectionChange(sessionId, !isSelected);
  };

  if (loading) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loading}>
          <Loader />
          <span>Chargement des sessions...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.error}>{error}</div>
      </div>
    );
  }

  if (noResults || sessions.length === 0) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.empty}>
          <p>Aucune session de formation trouvée.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              checked={chooseAll}
              onChange={handleChooseAll}
            />
          </div>
          <div className={styles.col}>Session</div>
          <div className={styles.col}>Date de début</div>
          <div className={styles.col}>Date de fin</div>
          <div className={styles.col}>Intervenant</div>
          <div className={styles.col}>Groupe</div>
          <div className={styles.col}>Statut</div>
        </div>
        {sessions.map((session, index) => (
          <Row
            item={session}
            key={session.id}
            index={index}
            value={selectedIds.includes(session.id)}
            onChange={() => handleRowSelectionChange(session.id)}
            onDelete={onDeleteSession}
            onDuplicate={onDuplicateSession}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
